<mat-card class="m-2" fxLayout="column">
    <mat-card-content [ngStyle]="{ height: height, width: width }" fxFlex="1 1 auto" class="element">
        <div>
            <div *ngIf="filePreview && !error; else fail" [ngSwitch]="filePreview.fileType">
                <ng-container *ngSwitchCase="types.VIDEO">
                    <app-player [audioEnabled]="filePreview.audio" [controls]="controls" [videoControl]="videoControl" (sourceError)="isError()"
                        (pauseTime)="pauseTime.emit($event)" [path]="filePreview.src"></app-player>
                </ng-container>
                <ng-container *ngSwitchCase="types.IMAGE">
                    <img *ngIf="filePreview.filename != 'empty-file'" (error)="isError()" [src]="filePreview.src">
                </ng-container>
            </div>
            <ng-template #fail>
                <div class="fail" fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon svgIcon="no_view"></mat-icon>
                    <h2 class="mr-auto ml-auto">{{'fileViewError' | translate}}</h2>
                </div>
            </ng-template>
            <app-text-content fxLayout="row" fxLayoutAlign="center center" *ngIf="filePreview.textContent" class="text"
                [textContent]="filePreview.textContent"></app-text-content>
        </div>
    </mat-card-content>
    <div *ngIf="progressEnabled" fxFlex="0 1 auto" class="element">
        <div>
            <mat-progress-bar [value]="progress" mode="determinate"></mat-progress-bar>
        </div>
    </div>
    <mat-card-actions fxFlex="0 1 auto" class="element" *ngIf="menuIcons">
        <div>
            <app-simple-icon-button-menu (buttonClicked)="buttonClicked.emit($event)"
                [menuIcons]="menuIcons"></app-simple-icon-button-menu>
        </div>
    </mat-card-actions>
</mat-card>